import { render, staticRenderFns } from "./AppTableHeader.vue?vue&type=template&id=b3973cb0&"
import script from "./AppTableHeader.vue?vue&type=script&lang=js&"
export * from "./AppTableHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports